module.exports = __webpack_public_path__ + "static/media/alpha_10.ec7b9c28.png";